import { mix, rgba } from 'polished'

export interface ColorsInterface {
  white: string
  black: string
  text: string
  pink: string
  blue: string
  grey: string
  darkYellow: string
  yellow: string
  lightYellow: string
  xlightYellow: string
  darkPink: string
  lightPink: string
  xlightPink: string
  pinkShadow: string
  darkBlue: string
  xlightBlue: string
  lightBlue: string
  blueShadow: string
  darkGrey: string
  lightGrey: string
  xlightGrey: string
  greyShadow: string
  darkGreen: string
  green: string
  lightGreen: string
  xlightGreen: string
  menu: string
  semanticGreen: string
  hoverColor: (color: string) => string
}

export const colors: ColorsInterface = {
  black: '#000',
  white: '#fff',
  text: '#000',
  pink: '#ff8e8e',
  darkPink: '#f57a7a',
  lightPink: '#f9c1c1',
  xlightPink: '#ffebeb',
  pinkShadow: rgba(250, 139, 139, 0.3),
  blue: '#149bbb',
  darkBlue: '#0f85a1',
  lightBlue: '#8acbda',
  xlightBlue: '#e1eff2',
  blueShadow: rgba(20, 155, 187, 0.3),
  darkYellow: '#ffcc00',
  yellow: '#ffd632',
  lightYellow: '#ffeb99',
  xlightYellow: '#ffffcb',
  grey: '#aeaeae',
  darkGrey: '#242424',
  lightGrey: '#eaeaea',
  xlightGrey: '#f8f8f8',
  greyShadow: rgba(172, 172, 172, 0.2),
  darkGreen: '#5CCCA3',
  green: '#67E5B7',
  lightGreen: '#A3EFD3',
  xlightGreen: '#E0F9F0',
  menu: '#757575',
  semanticGreen: '#007517',
  hoverColor: (color: string) => mix(0.2, '#fff', color),
}



// WEBPACK FOOTER //
// ./src/utils/theme/colors.ts